import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { UserDetailService } from 'src/app/core/services/user-detail.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-go-to-admin-button',
  standalone: true,
  imports: [
    CommonModule,
    MatTooltipModule,
    MatIconModule
  ],
  templateUrl: './go-to-admin-button.component.html',
  styleUrls: ['./go-to-admin-button.component.scss'],
})
export class GoToAdminButtonComponent {
  constructor(private userDetailService: UserDetailService){}

  get isAdmin() {
    return this.userDetailService.getUserData().isAdminRole
  }

  goToDrawoutAdmin() {
    window.open(environment.drawoutAdminRoute, "_blank");
  }
}
